import { useAuth } from '@saltus/auth';
import { AnalyticsEventInput } from '../graphql/API';
import { recordAnalyticsEvent } from '../graphql/queries';
import api from '../services/api';

function useAnalytics() {
  const { user, loading } = useAuth();

  const recordEvent = (analyticsEventInput: AnalyticsEventInput) => {
    if (!loading) {
      api
        .graphql({
          authMode: user ? 'userPool' : 'iam',
          variables: {
            input: analyticsEventInput,
          },
          query: recordAnalyticsEvent,
        })
        .catch(() => {});
    }
  };

  return {
    recordEvent,
  };
}

export default useAnalytics;
